import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import T from 'i18n-react';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: 200,
    borderWidth: 2,
    borderStyle: 'dotted',
  },
  icon: {
    color: theme.palette.primary.main,
  },
  image: {
    width: '100%',
    maxWidth: 200,
    height: 'auto',
    maxHeight: 200,
    objectFit: 'contain',
  },
}));

const UploadButton = ({ image, handleChange, side }) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Button
      component="label"
      startIcon={!image && <AddCircleOutlineIcon className={classes.icon} />}
      className={classes.root}
      style={{
        borderColor: image ? 'transparent' : theme.palette.primary.main,
      }}
    >
      {image ? (
        <img src={image} className={classes.image} />
      ) : (
        T.translate('user.certificates.uploadX', {
          x: T.translate(`user.certificates.${side}`),
        })
      )}
      <input
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleChange}
      />
    </Button>
  );
};

UploadButton.propTypes = {
  image: PropTypes.string,
  handleChange: PropTypes.func,
  side: PropTypes.oneOf(['front', 'back']),
};

export default UploadButton;
